<template>
    <app-content-admin>
      <template slot="header">Add Segmentation</template>
      <template slot="button">
        <v-btn
          style="margin-left: auto"
          large
          color="secondary"
          to="/segmentation"
        >
          Back
        </v-btn>
      </template>
  
      <v-layout row wrap>
        <v-flex xs12 lg6 mx-auto>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('Segmentation Name')"
                      v-model="form.segmentation_name"
                      :rules="[rules.required('Segmentation Name')]"
                      outlined
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

                   <!-- File Input Row -->
          <v-layout row wrap>
            <v-flex xs12>
              <div class="input-container">
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileUpload"
                  accept=".csv, .xlsx, .xls"
                  class="custom-file-input"
                />
              </div>
            </v-flex>
          </v-layout>

        


            <v-card-actions class="d-flex align-center justify-center" >
             
              
              <v-btn
                color="primary"
                @click="createSegmentation"
                class="form-submit  "
              >
                Submit
              </v-btn>
            
            </v-card-actions>



          </v-card>
        </v-flex>
      </v-layout>
    </app-content-admin>
  </template>
  
  <script>
  import vForm from "@/mixins/vForm";
  import ActiveLabel from "../../components/status/ActiveLabel.vue";
  import store from "@/store";
  
  export default {
    mixins: [vForm],
  
    data() {
      return {
        project_list: [],
        form: {
          id_segmentation: null,
          segmentation_name: null,
        },
        file: null,
      };
    },
  
    components: { ActiveLabel },
  
    created() {},
  
    computed: {},
  
    methods: {
      async createSegmentation() {
        let loader = this.$loading.show();
        console.log("Create form",this.form);
        try {
          let formData = new FormData();
        formData.append("segmentation_name", this.form.segmentation_name);
        formData.append("file", this.selectedFile); // Use the selected file here


           let res = await axios.post("/api/auth/create_segmentation", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set the correct content type
          },
        });
          if (res.status == 200) {
            console.log("Segmentation Created Success", res.template);
            this.$toastr.s("Segmentation created successfully");
            this.$router.push("/segmentation");
          }
        } catch (err) {
          if (err.response.status === 400) {
            // Validation errors returned by the server
            //  this.$toastr.e("Please input all required data");
          } else {
            // this.$toastr.e( "An error occurred while creating the AdZone.");
            console.log("Error create segmentation", err);
          }
        } finally {
          loader.hide();
        }
      },

      handleFileUpload(event) {
      // Store the selected file in the data property
      this.selectedFile = event.target.files[0];
      console.log("this file", this.selectedFile);
    },
    },
  };
  </script>
  
  <style>
  .textarea-wrap {
    position: relative;
    max-width: 100%;
    margin: auto;
  }
  
  .message-counter {
    position: absolute;
    right: 5px;
    bottom: 36px;
    font-size: 13px;
    color: black;
  }

  .input-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.custom-file-input {
  font-size: 18px;
  padding: 15px;
  border: 2px solid #4caf50;
  border-radius: 8px;
  background-color: #f2f2f2;
  color: #333;
}

.custom-file-input:hover {
  border-color: blueviolet;
}

  
  </style>
  